// extracted by mini-css-extract-plugin
export default {"title":"PageContent_title__bZ9MN","date":"PageContent_date__rVFAT","wrap":"PageContent_wrap__lswPw"};